import apiClient from './client'
import type { LoginCredentials, AuthResponse } from '@/types'

export const authAPI = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/login', credentials)
    return response.data
  },

  refresh: async (): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/refresh')
    return response.data
  },

  logout: async (): Promise<void> => {
    // Client-side logout only - token is removed from localStorage
    // Backend uses stateless JWT tokens
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  },
}
